import type { ReactNode } from 'react';
import { PARTY } from './lib';

interface PageShellProps {
  globalError: string | null;
  children: ReactNode;
}

export function PageShell({ globalError, children }: PageShellProps) {
  return (
    <div className="smash-page">
      {globalError && (
        <div className="smash-global-error" role="alert">
          {globalError}
        </div>
      )}
      {children}
      <footer className="smash-page__party-info">
        <h2 className="smash-page__party-info-heading">
          {PARTY.headline} Party details
        </h2>
        <dl className="smash-page__party-info-list">
          <div className="smash-page__party-info-row">
            <dt>When</dt>
            <dd>
              {PARTY.date}
              <br />
              {PARTY.time}
            </dd>
          </div>
          <div className="smash-page__party-info-row">
            <dt>Where</dt>
            <dd>
              {PARTY.venue}
              <br />
              {PARTY.address}
            </dd>
          </div>
        </dl>
      </footer>
    </div>
  );
}
